import React from 'react';

import { DODGER_BLUE, WHITE } from '@constant/colors';

const Static = () => (
  <svg viewBox="0 0 70 45" className="icon__advert-static">
    <g fill="none" fillRule="evenodd">
      <rect width="70" height="45" fill={DODGER_BLUE} rx="5" />
      <path
        fill={WHITE}
        d="M20.44 21.86l8.48-3.52v2.18l-6.1 2.36 6.1 2.38v2.24l-8.48-3.56v-2.08zm28.64 2.12L40.6 27.5v-2.18l6.08-2.34-6.08-2.4v-2.24l8.48 3.56v2.08zM36.24 15h2.18l-6.16 14.24h-2.18"
      />
    </g>
  </svg>
);

export default Static;
